<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<div #dropdown class="dropdown">
  <button #trigger class="btn dropdown-toggle" type="button" [class.active]="model.isActive" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false">
    <ng-container [kitComponent]="model.trigger"></ng-container>
  </button>

  <div #items class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <ng-container *ngFor="let item of model.items">
      <ng-container [kitComponent]="item" kitComponentClass="dropdown-item">
      </ng-container>
    </ng-container>
  </div>